import { IconBase } from './IconBase'

type IconMuteProps = React.ComponentProps<'svg'>

export const IconMute = (props: IconMuteProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#a)">
        <path d="M1.366.234.234 1.366l22.4 22.4 1.132-1.132-2.172-2.172A15.315 15.315 0 0 0 24 12.205a15.54 15.54 0 0 0-3.425-9.7.8.8 0 1 0-1.247 1.003 13.744 13.744 0 0 1 3.072 8.697c0 2.517-.684 4.94-1.973 7.09l-2.255-2.254a11.846 11.846 0 0 0 1.028-4.836c0-2.688-.882-5.236-2.55-7.37a.8.8 0 1 0-1.26.984 10.287 10.287 0 0 1 1.55 9.99l-2.618-2.618c.046-.326.078-.655.078-.986a7.329 7.329 0 0 0-2.04-5.077.8.8 0 0 0-1.158 1.105 5.742 5.742 0 0 1 1.57 3.408L8.8 7.669V5.6L7.74 6.608 1.365.234ZM2.4 8.8A2.4 2.4 0 0 0 0 11.2v1.6a2.4 2.4 0 0 0 2.4 2.4h3.036L8.8 18.4v-6.225L5.425 8.8H2.4Zm9.492 6.469c-.122.193-.24.39-.386.569a.8.8 0 1 0 1.24 1.009c.11-.135.211-.275.31-.416l-1.164-1.162Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </IconBase>
  )
}
